import { useEffect, useState } from 'react';
import * as zy from '../../common/zeroyear-1.0.0';
import { MDBRipple } from 'mdb-react-ui-kit';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/card.css'

export default function Portfolio () {
    const navigate = useNavigate();
    const [perfList, setPerfList] = useState([]);
    const imgClick = (event) => {
        let [seq, dv] = event.target.id.split('|');
        let url = '';
        switch (dv) {
            case '10': url = 'PerfPointDetailRoute'; break;
            case '20': url = 'PerfGeneralDetailRoute'; break;
            case '30': url = 'PerfCivilDetailRoute'; break;
            case '40': url = 'PerfEtcDetailRoute'; break;
        }
        navigate(`/${url}/${seq}`)
    };
    const selectAll = () => {
        zy.select('selectPerfMain', [], (item) => {
            setPerfList(item);
        });
    };
    useEffect(() => {
        selectAll();
    }, []);
    return (
        <section id="services" className="services">
            <div className="container">
                <div className="section-title">
                    <span>주요실적</span>
                    <h2>주요실적</h2>
                </div>
                <div className="row gy-4" data-aos="fade-up">
                    {   perfList.length === 0 ? (
                            <><hr></hr><div style={{textAlign: 'center'}}>등록 된 사진이 없습니다.</div><hr style={{marginTop: '20px'}}></hr></>
                        ) : 
                        <Row xs={2} md={4} className="g-3">
                        {perfList.map((perf) => {
                            let perfDvNm = '';
                            switch (perf.PERF_DV) {
                                case '10': perfDvNm = '지적측량'; break;
                                case '20': perfDvNm = '일반측량'; break;
                                case '30': perfDvNm = '토목설계'; break;
                                case '40': perfDvNm = '기타'; break;
                            }
                            return (
                                <Col key={perf.PERF_SEQ}>
                                    <Card className='perf-card-main'>
                                        <MDBRipple rippleTag='div' className='bg-image hover-overlay hover-zoom hover-shadow'>
                                            <Card.Img id={`${perf.PERF_SEQ}|${perf.PERF_DV}`} variant="top" src={perf.PERF_IMG} onClick={imgClick} style={{cursor: 'pointer'}} className="perf-card-img w-100"/>
                                            <a onClick={imgClick}>
                                                <div id={`${perf.PERF_SEQ}|${perf.PERF_DV}`} className='mask' style={{ backgroundColor: 'rgba(57, 192, 237, 0.2)' }}></div>
                                            </a>
                                        </MDBRipple>
                                        <Card.Body>
                                        <Card.Title>{perfDvNm}</Card.Title>
                                        <Card.Text>{perf.PERF_CONSTR_NM}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })}
                    </Row>}
                </div>
            </div>
        </section>
    );
}